/* src/app/ok-dialog/ReplyCommentDialog.component.scss */
.mat-mdc-dialog-title {
  color: var(--primary-color);
  line-height: 20px;
}
a {
  text-decoration: none;
}
blockquote {
  font-size: 1.5em;
  line-height: 1.5em;
  min-width: 400px;
  max-width: 600px;
  min-height: 50px;
  margin: 0px 0px;
  margin-bottom: 20px !important;
}
blockquote:before {
  content: open-quote;
}
blockquote:after {
  content: close-quote;
}
blockquote:before,
blockquote:after {
  display: inline-block;
  vertical-align: bottom;
  color: var(--primary-color);
  font-size: 3em;
  top: 0.2em;
  position: relative;
}
/*# sourceMappingURL=ReplyCommentDialog.component.css.map */
